const iBus = {
  //estacion_id: process.env.REACT_APP_RJ_ESTACION_ID,
  //punto_de_venta_id: process.env.REACT_APP_RJ_PUNTO_DE_VENTA_ID,
  //usuario_id: process.env.REACT_APP_RJ_USUARIO_ID,
  //user: process.env.REACT_APP_RJ_USUARIO,
  //pass: process.env.REACT_APP_RJ_PASS,
  tipoVentaId: 61
}

export default iBus